export default __webpack_public_path__ + "static/media/l.05600793.svg";